import { useAppStore } from '../../state/appStore';
import { useProgressStore } from '../../state/progressStore';
import { orderedLevels } from '../../levels';
import type { Transmission } from '../../sim/types';
import { useT } from '../hooks';
import { BigButton, Panel, ScreenShell, Stars } from '../components';

const TRACKS: Transmission[] = ['manual', 'auto'];

export function LevelSelect() {
  const t = useT();
  const { setScreen, openIntro, activeTrack, setTrack } = useAppStore();
  const progress = useProgressStore((s) => s.progress);

  return (
    <ScreenShell>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h2 className="min-w-0 flex-1 break-words text-2xl font-bold sm:text-3xl">{t('levels.title')}</h2>
        <BigButton className="shrink-0" variant="ghost" onClick={() => setScreen('menu')}>
          ← {t('settings.back')}
        </BigButton>
      </div>

      {/* Pestañas de itinerario */}
      <div className="flex gap-2">
        {TRACKS.map((track) => (
          <button
            key={track}
            onClick={() => setTrack(track)}
            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
              activeTrack === track
                ? track === 'manual'
                  ? 'bg-amber-400 text-slate-950'
                  : 'bg-sky-400 text-slate-950'
                : 'bg-white/10 text-white/70 hover:bg-white/20'
            }`}
          >
            {track === 'manual' ? '🦵 ' : '🕹 '}
            {t(`menu.track.${track}`)}
          </button>
        ))}
      </div>

      <div className="flex flex-col gap-3">
        {orderedLevels(activeTrack).map((level) => {
          const unlocked = progress.unlockedLevels.includes(level.id);
          const best = progress.bestScores[level.id];
          const stars: 0 | 1 | 2 | 3 = !best ? 0 : best >= 85 ? 3 : best >= 70 ? 2 : 1;
          return (
            <Panel
              key={level.id}
              className={`flex flex-col items-stretch justify-between gap-4 px-4 py-4 sm:flex-row sm:items-center sm:px-5 ${unlocked ? '' : 'opacity-50'}`}
            >
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="break-words text-lg font-semibold">{t(level.titleKey)}</span>
                  {best !== undefined && <Stars n={stars} />}
                </div>
                <p className="mt-1 line-clamp-2 text-sm text-white/60">{t(level.descriptionKey)}</p>
                {!unlocked && <p className="mt-1 text-xs text-amber-300/80">🔒 {t('levels.locked')}</p>}
                {best !== undefined && (
                  <p className="mt-1 text-xs text-white/40">
                    {t('levels.best')}: {best}/100
                  </p>
                )}
              </div>
              <BigButton className="w-full sm:w-auto" disabled={!unlocked} onClick={() => openIntro(level.id)}>
                {t('levels.play')}
              </BigButton>
            </Panel>
          );
        })}
      </div>
    </ScreenShell>
  );
}
